module.exports = __webpack_public_path__ + "static/upstairs-32c4329950855df40a64f7057e7dce17.jpg";